
export function lazyHtml2canvas(el: HTMLElement, opts?: any): Promise<HTMLCanvasElement> {
	return import('@vbrick/html2canvas')
		.then((module: any) => {
			return module.default(el, opts);
		});
}
